<template>
    <NuxtLink
        :to="$withLocalePrefix('/')"
        :class="{'navbar__logo--hidden': !isVisible}"
        :external="isExternalLink"
        data-testid="navbar-logo-link"
        class="navbar__logo"
    >
        <MaltImg class="navbar__logo-image" src="/cms-front/maltLogo.png" alt="Malt Logo" width="110" height="32" />
    </NuxtLink>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {MaltImg, NuxtLink} from '#components';
    import {useRoute} from '#imports';

    defineProps<{
        isVisible: boolean;
    }>();

    const route = useRoute();
    const isExternalLink = computed(() => route.path !== '/');
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .navbar__logo {
        position: relative;
        opacity: 1;
        transform: translate3d(0, 0, 0);
        transition:
            opacity calc(var(--navbar-transition-duration) * 0.4) var(--navbar-transition-easing) calc(var(--navbar-transition-duration) * 0.6),
            transform var(--navbar-transition-duration) var(--navbar-transition-easing);
        will-change: transform, opacity;
        backface-visibility: hidden;
        display: block;
        flex-shrink: 0;

        &-image {
            width: auto;
            height: 26px;
            display: block;

            /* The logo is a raster, so the transparent bar recolours it instead of swapping the file. */
            filter: var(--navbar-logo-filter, none);
            transition: filter var(--navbar-scroll-transition-duration) var(--navbar-transition-easing);
        }

        &:focus-visible {
            outline: var(--joy-core-spacing-0) solid var(--joy-color-neutral-40);
            outline-offset: var(--joy-core-spacing-2);
            border-radius: var(--joy-core-radius-3);
        }

        &--hidden {
            opacity: 0;
            transform: translate3d(-20px, 0, 0);
            pointer-events: none;
            transition-delay: 0s, 0s;
        }

        @include mq.screen_md(min) {
            transform: none;
            opacity: 1;
            display: flex;
            align-items: center;
            height: calc(var(--navbar-height) - var(--navbar-offset));

            &-image {
                height: 32px;
            }
        }
    }
</style>
